module.exports = __webpack_public_path__ + "img/deliveboo-1.14113b87.jpg";